export default __webpack_public_path__ + "static/media/person_blue.75848125.svg";